<!--
 * @Author: rossdong@yntengyun.com
 * @Date: 2024-10-21 10:08:03
 * @Description: 
-->
<template>
  <div class="color-[#FBFBFB]">
    <AHeader :data="params" />
    <!-- body -->
    <div class="mx-12" v-if="dealType == 'K1'">
      <div class=" mt-24 mb-12 text-[#333333] text-16  font-bold">
        考评信息
      </div>
      <div class="card-bg ">
        <div class="flex-col px-12 py-16">
          <div class="text-14" v-if="deduction">
            <div v-if="dealType == 'K1'">
              <p>扣分原因：{{ getK1DecutionReason() }}</p>
              <!-- <p v-if="audited == 1">审核时间：{{ auditedTime }}</p> -->
            </div>
            <div v-if="dealType == 'K2'">
              <p>游客满意率：{{ getSatisfactionStr() }} </p>
              <p class="mt-4">诱导、强迫游客取消退货数量：{{ getForceInduceRefundDeductionStr() }}</p>
            </div>
            <div v-if="dealType == 'K3'">{{ subtitle }} : {{ complainNumber }}件</div>
          </div>
          <div class="" v-else>暂无扣分</div>
        </div>
      </div>
    </div>

    <!-- k2 游客满意率 -->
    <div class="mx-12" v-if="dealType == 'K2'">
      <div class=" mt-24 mb-12 text-[#333333] text-16 font-bold  flex flex-row justify-between">
        <div>游客满意率</div>
        <div class="text-[#FF4D4D]">-{{ (satisfactionDeduction / 100).toFixed(1) }}</div>
      </div>
      <div class="card-bg">
        <div class="flex-col px-12 py-16 border-0 border-solid border-b border-b-[#EEEEEE]">
          <div class="text-16 font-bold">
            考评信息
          </div>
          <div class="text-14 text-[#666666] mt-16" v-if="satisfactionDeduction">
            扣分原因：满意率{{ getSatisfactionStr() }}
          </div>
          <div class="" v-else>暂无扣分</div>
        </div>
        <!-- 满意率 -->
        <div class="flex-col pt-24 ">
          <div class="text-14 font-bold px-12">
            游客情况满意率
          </div>
          <div>
            <div class="flex flex-col py-24 items-center border-0 border-solid border-b border-b-[#EEEEEE]">
              <div class="text-12 font-400 text-[#333333] flex flex-row gap-4">
                <span>满意度得分</span>
                <van-popover v-model="showPopover" trigger="click" theme="dark">
                  <div class="text-14 px-8 py-12 max-w-240 text-[#e4e3e3]">
                    <span>{{ k2Rule }}</span>
                  </div>
                  <template #reference>
                    <img src="@/assets/appraise/ic_appraise_help.png" class="size-12 object-scale-down" />
                  </template>
                </van-popover>
              </div>
              <div class="text-32 font-bold text-[#36B374] mt-6">{{ satisfaction }}</div>
            </div>
            <div class="flex flex-row h-72 ">
              <div
                class="flex-1 flex flex-col items-center justify-center border-0 border-solid border-r border-r-[#EEEEEE]">
                <div class="text-12 text-[#333333] font-400">满意</div>
                <div class="text-20 text-[#36B374] font-700 mt-8">
                  {{ satisfactionNum ?? 0 }}
                  <span class="text-10 text-[#36B374] font-400">件</span>
                </div>
              </div>

              <div class="flex-1 flex flex-col items-center justify-center">
                <div class="text-12 text-[#333333] font-400">不满意</div>
                <div class="text-20 text-[#36B374] font-700 mt-8">
                  {{ unsatisfiedNum ?? 0 }}
                  <span class="text-10 text-[#36B374] font-400">件</span>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- k2 诱导、强迫游客取消退货 -->
    <div class="mx-12" v-if="dealType == 'K2'">
      <div class=" mt-24 mb-12 text-[#333333] text-16 font-bold  flex flex-row justify-between">
        <div>诱导、强迫游客取消退货</div>
        <div class="text-[#FF4D4D]">-{{ (Number(forceInduceRefundDeduction) / 100).toFixed(1) }}</div>
      </div>
      <div class="card-bg">
        <div class="flex-col px-12 py-16 border-0 border-solid border-b border-b-[#EEEEEE]">
          <div class="text-16 font-bold">
            考评信息
          </div>
          <div class="text-14 text-[#666666] mt-16" v-if="!isNaN(forceInduceRefundDeduction)">
            扣分原因：诱导、强迫游客取消退货 {{ getForceInduceRefundDeductionStr() }}
          </div>
          <div class="text-12 text-[#666666] mt-16" v-else>暂无扣分</div>
        </div>
        <!-- 满意率 -->
        <div class="flex-col py-24 ">
          <div class="text-14 font-bold px-12 ">
            扣分记录
          </div>
          <!-- 扣分列表 -->
          <div v-if="decutionList.length">
            <div class="flex flex-col pt-16 pb-16 px-12 text-12 text-[#666666] font-400"
              v-for="(item, index) in decutionList" :key="index"
              :style="index != decutionList.length - 1 ? 'border-bottom: 1px #EEEEEE solid;' : ''">
              <div class="flex flex-row">
                <div class="flex-none ">退货单号：</div>
                <div class="flex-1 ">{{ item.orderNumber }}</div>
              </div>
              <div class="flex flex-row mt-16">
                <div class="flex-none ">回访结果：</div>
                <div class="flex-1 ">{{ item.withdraw }}</div>
              </div>
              <div class="flex flex-row mt-16">
                <div class="flex-none ">退货时间：</div>
                <div class="flex-1 ">{{ item.createTime }}</div>
              </div>
              <div class="mt-16 text-[#36b374] flex items-center  w-180 h-12" @click="gotoK2Detail(item)">
                <div class="">查看详情</div>
                <img src="../../../assets/image/tb-right.png" class="object-contain size-10" />
              </div>
            </div>
          </div>
          <div v-else class=" text-12 text-[#666666] ml-12 mt-16">暂无扣分</div>
        </div>
      </div>
    </div>

    <!-- k3 -->
    <div class="mx-12" v-if="dealType == 'K3'">
      <div class=" mt-24 mb-12  flex flex-row gap-4 items-end">
        <div class="text-[#333333] text-16  font-bold"> 考评信息</div>
        <van-popover v-model="showK3Popover" trigger="click" theme="dark" placement="bottom-start" :offset="[-10, 16]">
          <div class="text-14 px-8 py-12 max-w-240 text-[#e4e3e3]">扣分规则：每件扣0.1分，上限1分</div>
          <template #reference>
            <img src="@/assets/appraise/ic_appraise_help.png" class="size-12 object-scale-down" />
          </template>
        </van-popover>
      </div>
      <div class="card-bg ">
        <div class="flex-col px-12 py-16 text-14 text-[#666666]">
          <div class="" v-if="deduction">
            <p>扣分原因：{{ getRefundComplaintStr() }}</p>
          </div>
          <div class="" v-else>暂无扣分</div>
        </div>
      </div>

      <div class=" mt-24 mb-12 text-[##666666] text-16  font-bold">
        扣分记录
      </div>
      <div v-if="decutionList.length" class="card-bg ">
        <div class="flex flex-col pt-16 pb-16 px-12 text-12 text-[#666666] font-400 "
          v-for="(item, index) in decutionList" :key="index"
          :style="index != decutionList.length - 1 ? 'border-bottom: 1px #EEEEEE solid;' : ''">
          <div class="flex flex-row">
            <div class="flex-none ">投诉单号：</div>
            <div class="flex-1 ">{{ item.orderNo }}</div>
          </div>
          <div class="flex flex-row mt-16 ">
            <div class="flex-none ">所属区域：</div>
            <div class="flex-1 ">{{ item.cityName }}</div>
          </div>
          <div class="flex flex-row mt-16">
            <div class="flex-none ">投诉时间：</div>
            <div class="flex-1 ">{{ item.createTime }}</div>
          </div>
          <div class="mt-16 text-[#36b374] flex items-center  w-180 h-12" @click="gotoK3Detail(item)">
            <div class="">查看详情</div>
            <img src="../../../assets/image/tb-right.png" class="object-contain size-10" />
          </div>
        </div>
      </div>
      <div v-else class="card-bg py-16 px-12">
        暂无数据
      </div>
    </div>

  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { audit } from '@/service/modules/refund';
import AAssessInfo from './components/AAssessInfo.vue';
import AHeader from './components/AHeader.vue';
import API from '@/service/index';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    AAssessInfo, AHeader
  },
  name: 'kCategoryDetail',
  props: {

  },
  data() {
    // 这里存放数据
    return {
      k2Rule: `扣分规则：\n游客满意率<=99.5%，不扣分\n99.09≤游客满意率<99.5％，扣0.5分\n98.5%≤游客满意率<99.0%，扣1分\n98%≤游客满意率<98.5%，扣1.5分\n游客满意率<98%，扣2分`,
      satisfactionNum: '', //query 中传递来了
      unsatisfiedNum: '',
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      area: this.$route.query.area,
      auditedTime: '',
      showPopover: false,
      satisfactionDeduction: 0,
      satisfaction: 0,
      forceInduceRefundNumber: 0,
      forceInduceRefundDeduction: 0,
      params: {
        monitorTypeCN: this.$route.query.projectname,
        deduction: this.$route.query.deduction,
        areaName: this.$route.query.areaName,
        monitorDate: this.$route.query.quarterName
      },
      deduction: Number(this.$route.query.deduction),
      dealType: this.$route.query.dealType,
      ...this.$route.query,
      decutionList: [],
      pageSize: 20,
      currentPage: 1,
      complainType: '7', // 1: 投诉5分钟内未响应情况, 2:投诉超过24小时未办结情况, 3:投诉办结率24小时未达95%
      showK3Popover:false,

    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // k2 扣分记录
    getCityRefundDealPageList() {
      let param = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        data: {
          areaCode: this.area,
          // orderNumber:this.searchValue,
          quarter: this.quarter,
          year: this.year
        }
      }
      API.getCityRefundDealPageList(param).then(res => {
        if (res && res.data) {
          this.decutionList = res.data.list;
        }
      })
    },
    // k3扣分记录
    getCityComplainDealPageList() {
      let param = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        data: {
          complainType: this.complainType,
          area: this.area,
          // orderNumber:this.searchValue,
          quarter: this.quarter,
          year: this.year
        }
      }
      API.getCityComplainDealPageList(param).then(res => {
        if (res.ret == 0 && res.data) {
          this.decutionList = res.data.content;
        }
      })
    },

    getK1DecutionReason() {
      let result = ''
      if (this.deduction == 0) {
        result = '未发生扣分情况'
      } else {
        result = `完成率${this.percentage}%,扣${(this.deduction / 100).toFixed(1)}分`
      }
      return result
    },
    getSatisfactionStr() {
      if (this.satisfactionDeduction == 0) {
        return `${this.satisfaction},不扣分`
      }
      return `${this.satisfaction},扣${(this.satisfactionDeduction / 100).toFixed(1)}分`
    },
    getForceInduceRefundDeductionStr() {
      if (this.forceInduceRefundDeduction == 0) {
        return `${this.forceInduceRefundNumber}起,0扣分`
      }
      return `${this.forceInduceRefundNumber}起，扣${(this.forceInduceRefundDeduction / 100).toFixed(1)}分${this.forceInduceRefundDeduction >= 100 ? '（已达扣分上限）' : ''}`
    },

    gotoK2Detail(item) {
      // this.openWindow(item.url)
      this.$router.push({
        path: '/refund/refundDetail',
        query: {
          flowId: item.id
        }
      })
    },

    gotoK3Detail(item) {
      let url  = `yyngov://complaint?path=complain_detail_container&mainComplainNumber=${item.orderNo}&complainNumber=${item.orderSubNo}&subID=${item.id}`
      this.openWindow(url)
    },

    openWindow(url) {
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: url,
          isFullScreen: 1,
          // setTitle: title,
          needLoading: 1,
        },
        (cb) => {
          console.log(cb, "callback");
        }
      );
    },
    getRefundComplaintStr() {
      if (this.complainNumber == 0) {
        return "暂无数据"
      }
      return `因退货处置不当引发游客投诉${this.complainNumber}件，扣${(this.deduction / 100).toFixed(1)}分`
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log("🚀 ~ created ~ created:", this.$route.query)
    if (this.dealType == "K2") {
      this.getCityRefundDealPageList()
    } else if (this.dealType == "K3") {
      this.getCityComplainDealPageList()
    }

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//  @import url(); 引入公共css类
.card-bg {
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
}
</style>